import React, { Component } from "react";
import { NavLink } from "react-router-dom";

/*LIBRARIES FOR MATERIAL UI */
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import AccountBox from "@material-ui/icons/AccountBox";
import MenuIcon from "@material-ui/icons/Menu";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import MuiThemeProvider from "@material-ui/core/styles/MuiThemeProvider";
import { createMuiTheme } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import IpmIcon from "../../images/logo512@2x.png";

//Logout button
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import Clear from "@material-ui/icons/Clear";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actions from "./redux/actions";

//Redirect to login
import { Redirect } from "react-router-dom";
import { withRouter } from "react-router";
import AvatarComponent from "react-rounded-image";

import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ShowChart from "@material-ui/icons/ShowChart";
import Face from "@material-ui/icons/Face";
import People from "@material-ui/icons/People";
import Business from "@material-ui/icons/Business";
import Category from "@material-ui/icons/Category";
import Euro from "@material-ui/icons/EuroSymbol";
import Description from "@material-ui/icons/Description";

import {ROLE_SUPER} from './redux/constantes';


/* size of width panel*/
const drawerWidth = 100;

/*Styling */
const styles = (theme) => ({
  "@global": {
    body: {
      backgroundColor: "#fff",
    },
  },
  myBarItem: {
    float: "left",
  },
  root: {},
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    marginLeft: drawerWidth,
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
    },
  },
  menuButton: {
    marginRight: 20,
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
    background: "#243043",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: "100px",
    },
  },
  usernameTitle: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "inline-block",
    },
  },
});

class MySideBar extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
  };

  state = {
    mobileOpen: false,
    anchorEl: null,
    openAdmin: false,
    projectName: "",
  };
  constructor(props){
    super(props)
    this.chatContainer = React.createRef()
  }
  componentDidMount(){
    this.scriptLoader()
  }
 scriptLoader=()=>{
    let element=document.querySelector("iframe");
    if(element===null&&this.props.location.pathname==="/"){
      const script = document.createElement("script")
      script.defer= true   
      script.id= "chat-widget"
      script.src="https://pems.outseta.com/Scripts/client/dist/outseta.chat.widget.min.js"
      this.chatContainer.appendChild(script);
    }else if(element!==null&&this.props.location &&this.props.location.pathname!=="/"&&window.Outseta&&window.Outseta.chat){
      window.Outseta.chat.hide()
    }else  if(element!==null&&this.props.location &&this.props.location.pathname==="/"&&window.Outseta&&window.Outseta.chat){
      window.Outseta.chat.show()
    }
  }


  handleMenu = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleDrawerToggle = () => {
    this.setState((state) => ({ mobileOpen: !state.mobileOpen }));
  };

  doLogout = () => {
    this.props.actions.doLogout();
    window.location.href = 'https://pems.io/login'
  }

  toggleOpenAdmin = () => {
    this.setState({ openAdmin: !this.state.openAdmin });
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.location !== undefined) {
      let routePath = nextProps.location.pathname;
      if (routePath.substr(0, 5) === "/wbs/") {
        this.setState({
          projectName: routePath.substr(5, routePath.length),
        });
        localStorage.setItem(
          "projectName",
          routePath.substr(5, routePath.length)
        );
      } else {
        this.setState({
          projectName: "",
        });
      }
    }
  }

  render() {
    /*Theme and classes */
    const { classes } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    const theme1 = createMuiTheme({
      palette: {
        type: "dark",
      },
    });

    /*Panel Structure */
    /*style={{marginLeft:'30%', marginTop:'15%'}} */
    const drawer = (
      <div style={{ maxWidth: "100%" }}>
        <div ref={el => (this.chatContainer = el)}></div>
        <div className={classes.toolbar}>
          <Avatar
            className={classes.bigAvatar}
            imgProps={{
              style: {
                marginTop: 6,
              },
            }}
            src={IpmIcon}
            style={{
              alignItems: "center",
              display: "flex",
              justifyContent: "center",
              padding: 0,
              borderRadius: 0,
              minWidth: 45,
              minHeight: 59,
              marginLeft: 24,
              marginTop: 0,
              marginBottom: 0,
            }}
          />
        </div>
        <Divider />
        {Number(localStorage.getItem("role")) === ROLE_SUPER ? (
          <div style={{ padding: 0, margin: 0 }}>
            <ListItem
              button
              key={"user"}
              component={NavLink}
              to="/"
              style={{ paddingLeft: "8%", marginLeft: "5px" }}
            >
              <div className="myBarItem">
                <ListItemIcon>
                  <People
                    style={{ marginLeft: "40%", height: "55%", width: "55%" }}
                  />
                </ListItemIcon>
                <ListItemText
                  style={{ textAlign: "center", fontSize: "0.8em" }}
                  primary={"Projects"}
                />
              </div>
            </ListItem>
            <ListItem
              button
              key={"company"}
              component={NavLink}
              to="/company"
              style={{ paddingLeft: "0px", marginLeft: "0px" }}
            >
              <div className="myBarItem">
                <ListItemIcon>
                  <Business
                    style={{ marginLeft: "35%", height: "55%", width: "55%" }}
                  />
                </ListItemIcon>
                <ListItemText
                  style={{ textAlign: "center", fontSize: "0.8em" }}
                  primary={"Business"}
                />
              </div>
            </ListItem>
          </div>
        ) : (
          <List>
            <ListItem
              button
              key={"project"}
              component={NavLink}
              to="/"
              style={{ paddingLeft: "7%" }}
            >
              <div className="myBarItem">
                <ListItemIcon>
                  <AccountBox
                    style={{ marginLeft: "40%", height: "30%", width: "30%" }}
                  />
                </ListItemIcon>
                <ListItemText
                  style={{ textAlign: "center" }}
                  primary={"Projects"}
                />
              </div>
            </ListItem>
            <ListItem
              button
              key={"Admin"}
              onClick={this.toggleOpenAdmin}
              style={{ paddingLeft: "7%" }}
            >
              <div className="myBarItem">
                <ListItemIcon
                  style={{ marginLeft: "40%", height: "30%", width: "30%" }}
                >
                  {this.state.openAdmin ? <ExpandLess /> : <ExpandMore />}
                </ListItemIcon>
                <ListItemText primary="Admin" />
              </div>
              <div style={{ float: "right" }}></div>
            </ListItem>
            <Collapse in={this.state.openAdmin} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  key={"phase"}
                  component={NavLink}
                  to="/phase"
                  style={{ paddingLeft: "8%" }}
                >
                  <div className="myBarItem">
                    <ListItemIcon>
                      <ShowChart
                        style={{
                          marginLeft: "40%",
                          height: "30%",
                          width: "30%",
                        }}
                      />
                    </ListItemIcon>
                    <ListItemText
                      style={{ textAlign: "center" }}
                      primary={"Phases"}
                    />
                  </div>
                </ListItem>
                <ListItem
                  button
                  key={"unit"}
                  component={NavLink}
                  to="/unit"
                  style={{ paddingLeft: "15%" }}
                >
                  <div className="myBarItem">
                    <ListItemIcon>
                      <Category
                        style={{
                          marginLeft: "40%",
                          height: "35%",
                          width: "35%",
                        }}
                      />
                    </ListItemIcon>
                    <ListItemText
                      style={{ textAlign: "center" }}
                      primary={"Units"}
                    />
                  </div>
                </ListItem>
                <ListItem
                  button
                  key={"currency"}
                  component={NavLink}
                  to="/currency"
                  style={{ margin: 0 }}
                >
                  <div className="myBarItem" style={{ marginLeft: "-30%" }}>
                    <ListItemIcon>
                      <Euro
                        style={{
                          marginLeft: "40%",
                          height: "25%",
                          width: "25%",
                        }}
                      />
                    </ListItemIcon>
                    <ListItemText
                      style={{ textAlign: "center" }}
                      primary={"Currencies"}
                    />
                  </div>
                </ListItem>
                <ListItem
                  button
                  key={"member"}
                  component={NavLink}
                  to="/member"
                  style={{ paddingLeft: "6%" }}
                >
                  <div className="myBarItem">
                    <ListItemIcon>
                      <Face
                        style={{
                          marginLeft: "40%",
                          height: "30%",
                          width: "30%",
                        }}
                      />
                    </ListItemIcon>
                    <ListItemText
                      style={{ textAlign: "center" }}
                      primary={"Members"}
                    />
                  </div>
                </ListItem>
                <ListItem
                  button
                  key={"dc"}
                  component={NavLink}
                  to="/Dc"
                  style={{ paddingLeft: "6%" }}
                >
                  <div className="myBarItem">
                    <ListItemIcon>
                      <Description
                        style={{
                          marginLeft: "40%",
                          height: "30%",
                          width: "30%",
                        }}
                      />
                    </ListItemIcon>
                    <ListItemText
                      style={{ textAlign: "center" }}
                      primary={"Catalogs"}
                    />
                  </div>
                </ListItem>
                {/*
                  Number(localStorage.getItem("role"))===ROLE_ADMIN?
                  (
                    <ListItem button key={"user"} component={NavLink} to="/user" style={{paddingLeft:'8%', marginLeft:'5px'}}>
                      <div className="myBarItem">
                        <ListItemIcon ><People style={{marginLeft:'40%',height:'45%', width:'45%'}}/></ListItemIcon>
                        <ListItemText style={{textAlign:'center'}} primary={"Users"} />
                      </div>
                    </ListItem>
                  ):null*/
                }
                
              </List>
            </Collapse>
          </List>
        )}
      </div>
    );

    return (
      <div>
         {!localStorage.getItem("logged") ? (
          window.location.href = 'https://pems.io/login'
        ) : Number(localStorage.getItem("role")) === ROLE_SUPER &&
          (this.props.location.pathname !== "/profile/Profile" &&
            this.props.location.pathname !== "/company" &&
            this.props.location.pathname !== "/")&&
            !this.props.location.pathname.startsWith("/wbs") ? (
          <Redirect push to={"/"} />
        ) : (
          <div className={classes.root}>
            <CssBaseline />
            <AppBar
              position="fixed"
              className={classes.appBar}
              style={{ backgroundColor: "#243043" }}
            >
              <Toolbar>
                <IconButton
                  color="inherit"
                  aria-label="Open drawer"
                  onClick={this.handleDrawerToggle}
                  className={classes.menuButton}
                >
                  <MenuIcon />
                </IconButton>
                <Typography variant="h6" color="inherit" noWrap>
                  PEMS 2.0
                </Typography>
                <Typography
                  variant="subtitle2"
                  style={{ marginLeft: "2%", color: "#E6E6E6" }}
                  noWrap
                >
                  {this.state.projectName
                    ? "Project: " + this.state.projectName
                    : ""}
                </Typography>
                <div
                  style={{ float: "right", right: "2%", position: "absolute" }}
                >
                  <IconButton
                    aria-owns={open ? "menu-appbar" : undefined}
                    aria-haspopup="true"
                    onClick={this.handleMenu}
                    color="inherit"
                  >
                    <AvatarComponent
                      image={
                        "data:image/png;base64," +
                        localStorage.getItem("avatar")
                      }
                      roundedColor="#151515"
                      imageWidth="45"
                      imageHeight="45"
                      roundedSize="2"
                    />
                  </IconButton>
                  <span
                    style={{ fontSize: "0.8em" }}
                    className={classes.usernameTitle}
                  >
                    {localStorage.getItem("username")}
                  </span>
                  <Menu
                    id="menu-appbar"
                    anchorEl={anchorEl}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    open={open}
                    onClose={this.handleClose}
                  >
                    <MenuItem component={NavLink} to="/profile/Profile">
                      {" "}
                      Profile{" "}
                    </MenuItem>
                    <MenuItem onClick={this.doLogout}>
                      Logout <Clear style={{ marginLeft: "10%" }} />{" "}
                    </MenuItem>
                  </Menu>
                </div>
              </Toolbar>
            </AppBar>
            <MuiThemeProvider theme={theme1}>
              <nav className={classes.drawer}>
                {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                <Hidden smUp implementation="css">
                  <Drawer
                    container={this.props.container}
                    variant="temporary"
                    anchor={"left"}
                    open={this.state.mobileOpen}
                    onClose={this.handleDrawerToggle}
                    classes={{
                      paper: classes.drawerPaper,
                    }}
                  >
                    {drawer}
                  </Drawer>
                </Hidden>
                <Hidden xsDown implementation="css">
                  <Drawer
                    classes={{
                      paper: classes.drawerPaper,
                    }}
                    variant="permanent"
                    open
                  >
                    {drawer}
                  </Drawer>
                </Hidden>
              </nav>
            </MuiThemeProvider>
            <main className={classes.content}>
              <div className={classes.toolbar} />
              <div>{this.props.children}</div>
            </main>
          </div>
        )}
      </div>
    );
  }
}

MySideBar.propTypes = {
  classes: PropTypes.object.isRequired,
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    MySideBar: state.MySideBar,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(styles)(MySideBar))
);



// WEBPACK FOOTER //
// ./src/features/common/MySideBar.js